// Add ECMA262-5 string trim if not supported natively
//
if (!('trim' in String.prototype)) {
    String.prototype.trim= function() {
        return this.replace(/^\s+/, '').replace(/\s+$/, '');
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/autobahn/lib/polyfill/string.js
// module id = 653
// module chunks = 0